import {ToggleSwitch} from "../ui/ToggleSwitch";

export const FormatCellAutoRenewal = ({ order }) => {
  return (
    <ToggleSwitch order={order} />
  );
};
